import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid, parseOptions} from '../question-helper';
import {GlobalQuestionService} from '../../services/global-question.service';
import {NgxCurrencyConfig, NgxCurrencyInputMode} from 'ngx-currency';

@Component({
    selector: 'app-question-specified-items',
    templateUrl: './question-specified-items.component.html',
    styleUrls: ['./question-specified-items.component.scss'],
    standalone: false
})
export class QuestionSpecifiedItemsComponent implements OnInit, AfterViewInit {

  @Input() question: Question;
  @Output() questionAnswer = new EventEmitter<any>();

  maskOptions: NgxCurrencyConfig;
  options: any[] = [];
  enteredItems: any[] = [];
  uniqueAmountName = `item-value-${newGuid()}`;
  uniqueDescriptionName = `item-value-${newGuid()}`;
 processing = false;
  constructor(public questionService: GlobalQuestionService) {
  }

  ngOnInit(): void {
    if (this.question?.options) {
      this.options = parseOptions(this.question.options);
      this.questionService.getItemList(this.question.cent_aq_question_id).subscribe(items => {
        if (items.length>0){
          items.forEach(item => {
            var d = item.details.split('|');
            this.enteredItems.push({Category: d[0], Description: d[2], Amount: d[1], Premium: 0, ItemId: item.item_id});
          });
          this.question.answer = "Answered";
          this.questionAnswer.emit(this.question);
          
        }
        else{
          this.enteredItems.push({Category: '', Description: '', Amount: 0, Premium: 0, ItemId: 1 });
        }
        this.saveValue();
       
      });
      
    }
  }

  ngAfterViewInit(): void {
    this.maskOptions = {
      max: this.question?.max_val,
      min: null,
      allowZero: true,
      nullable: false,
      inputMode: NgxCurrencyInputMode.Financial,
      align: 'left',
      allowNegative: false,
      prefix: 'R ',
      decimal: '.',
      suffix: '',
      thousands: ' ',
      precision: 0
    };
  }

  addAnother(): void {
    if (this.enteredItems.every(item => item.RegistrationNumber && item.Value && item.TrackingDevice)) {
      this.enteredItems.push({Category: '', Description: '', Amount: 0, Premium: 0});
    }
    
    this.questionService.getItemList(this.question.cent_aq_question_id).subscribe(items =>{
      console.log(Number(items[0].max) + 1);
      this.enteredItems.push({Category: '', Description: '', Amount: 0, Premium: 0, ItemId: Number(items[0].max)+ 1});
    });
   
  }

  removeSpaces(value: string): string {
    return value.replace(/\s/g, '-').replace(/[^\w\s]/gi, '-');
  }

  selectChange(value: string, index: number): void {
    this.enteredItems[index].Category = value;
    this.saveValue();
  }

  onInputChange(index: number): void {
    this.saveValue();
  }

  saveValue(): void {
    if (this.question && this.enteredItems.every(item => item.Category && item.Description && item.Amount)) {
      for (let i = 0; i < this.enteredItems.length; i++) {
        let value = '';
        value += this.enteredItems[i].Category + '|';
        value += this.enteredItems[i].Amount + '|';
        value += this.enteredItems[i].Description;
        let item_id = this.enteredItems[i].ItemId;
        this.getPremium(item_id, value);
      }
    }
    
  }

  getPremium(index: any, answer: any): void {
      this.question.answer = answer;
      this.processing = true;
      this.questionService.saveIndividualAnswer(this.question, index)
        .subscribe(x => {
          this.questionService.getPremium(this.question.product_class_id, index, this.question?.product_id)
            .subscribe(r => {
              if (r?.length) {
                this.enteredItems.forEach(element => {
                  if (element.ItemId == index){
                    element.Premium = r[0]?.premium;;
                  }
                });
                //this.enteredItems[index].Premium = r[0]?.premium;
              }
            
                this.questionAnswer.emit(this.question);
                this.processing = false;
              
            }, error => { this.processing = false});
        });
  }
}
